import { Title, TitleBar } from '@/components/_common';
import { Grid } from '@mui/material';

const NewScheduleTitle = () => {
  return (
    <TitleBar style={{ marginBottom: 0 }}>
      <Grid container justifyContent="space-between" alignItems="center">
        <Title>New Schedule</Title>
      </Grid>
    </TitleBar>
  );
};

export default NewScheduleTitle;
